/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { combineClassNames } from 'core/css';
import { CLASSNAME_UPDATING } from '../../../constants';
import Spinner from '../../../common/spinner/Spinner';

export const GridCardPrimarySection = (props) => {
  const { children, className, height, primaryRef } = props;
  return (
    <div
      ref={primaryRef}
      className={combineClassNames('card-container__primary', className)}
      style={height ? { height: `${height}px` } : {}}>
      {children}
    </div>
  );
};

export const GridCardSecondarySection = (props) => {
  const { children, className } = props;
  return (
    <div className={combineClassNames('card-container__secondary', className)}>
      {children}
    </div>
  );
};

export const GridCard = ({
  className,
  children,
  checked,
  onClick,
  isUpdating,
  isUpdatingOption,
  analyticsKey,
  analyticsKey2 = null,
  wait,
  animation = {},
}) => {
  const { animate } = animation;
  const [hidden, setHidden] = useState(animate);

  useEffect(() => {
    let animationTimer;

    if (animate) {
      animationTimer = setTimeout(() => setHidden(false), wait);
    }

    return () => {
      clearTimeout(animationTimer);
    };
  }, []);

  return (
    <div
      onClick={onClick}
      className={combineClassNames(
        'card-container',
        'card-container--column',
        'card-container--grid',
        className,
        animate && hidden ? 'card-container--hidden' : '',
        checked && 'card-container--checked',
        isUpdating && !isUpdatingOption && CLASSNAME_UPDATING
      )}
      aria-checked={checked}
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}>
      <>
        {children}
        {isUpdatingOption && <Spinner className="svg-icon--center"></Spinner>}
      </>
    </div>
  );
};

export default GridCard;
